<template>
	<div>
		<div style="display: flex; justify-content: flex-end;">
			<el-button type="success" style="margin-right: 10%;" @click="toShow">日志<i class="el-icon-d-arrow-right"></i></el-button>
		</div>
		<div style="display: flex; justify-content: center;">
			<el-form label-width="120px" :model="form">
				<el-form-item>
					<h2 style="display: flex; justify-content: center;">信息录入界面</h2>
				</el-form-item>
				<el-form-item label="登记号">
					<el-input v-model="form.PapmiDJH" style="width: 200px;" @keyup.enter.native="getPatientInfo" clearable @clear="clearInfo" />
				</el-form-item>
				<el-form-item label="姓名">
					<el-input class="color-black" v-model="form.PapmiName" style="width: 200px;" disabled />
				</el-form-item>
				<el-form-item label="手机号">
					<el-input class="color-black" v-model="form.PapmiTelH" style="width: 200px;" disabled />
				</el-form-item>
				<el-form-item label="性别">
					<el-radio-group v-model="form.PapmiSex">
						<el-radio v-if="form.PapmiSex === '1'" label="1">男</el-radio>
						<el-radio v-if="form.PapmiSex === '2'" label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="出生日期">
					<el-date-picker v-model="form.PapmiDob" type="date" placeholder="出生日期" format="yyyy-MM-DD" value-format="yyyy-MM-DD" style="width: 200px;">
						<template #default="cell">
							<div class="cell" :class="{ current: cell.isCurrent }">
								<span class="text">{{ cell.text }}</span>
							</div>
						</template>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="年龄">
					<el-input v-model="form.PapmiAge" style="width: 80px; margin-right: 5px;" /><span>岁</span>
				</el-form-item>
				<el-form-item label="右眼-医学验光">
					<el-input @change="rightDegree" v-model="form.YXYGDSYY" type="number" style="width: 80px; margin-right: 10px;" /><span> DS </span>
					<el-input v-model="form.YXYGDCYY" type="number" style="width: 80px; margin-left: 10px; margin-right: 10px;" /><span> DC x </span>
					<el-input v-model="form.YXYGXYY" type="number" style="width: 80px; margin-left: 10px;" />
				</el-form-item>
				<el-form-item label="右眼-设计度数">
					<el-input @change="rightDegree" v-model="form.SJDSDSYY" type="number" style="width: 80px; margin-right: 10px;" /><span> DS </span>
					<el-input v-model="form.SJDSDCYY" type="number" style="width: 80px; margin-left: 10px; margin-right: 10px;" /><span> DC x </span>
					<el-input v-model="form.SJDSXYY" type="number" style="width: 80px; margin-left: 10px;" />
				</el-form-item>
				<el-form-item label="左眼-医学验光">
					<el-input @change="leftDegree" v-model="form.YXYGDS" type="number" style="width: 80px; margin-right: 10px;" /><span> DS </span>
					<el-input v-model="form.YXYGDC" type="number" style="width: 80px; margin-left: 10px; margin-right: 10px;" /><span> DC x </span>
					<el-input v-model="form.YXYGX" type="number" style="width: 80px; margin-left: 10px;" />
				</el-form-item>
				<el-form-item label="左眼-设计度数">
					<el-input @change="leftDegree" v-model="form.SJDSDS" type="number" style="width: 80px; margin-right: 10px;" /><span> DS </span>
					<el-input v-model="form.SJDSDC" type="number" style="width: 80px; margin-left: 10px; margin-right: 10px;" /><span> DC x </span>
					<el-input v-model="form.SJDSX" type="number" style="width: 80px; margin-left: 10px;" />
				</el-form-item>
				<el-form-item v-show="isShow" label="度数变化">
					<span> 右眼: </span><el-input v-model="form.DSBHYY" type="number" class="color-red" style="width: 80px; margin-left: 5px;"></el-input>
					<span> 左眼: </span><el-input v-model="form.DSBH" type="number" class="color-red" style="width: 80px; margin-left: 5px; margin-right: 5px;" ></el-input>
				</el-form-item>
				<el-form-item>
					<div style="display: inline-flex;">
						<el-button @click="clearDS" type="danger" style="width: 100px; margin-top: 10px;margin-right: 20px;">清除度数</el-button>
						<el-button @click="clearInfo" type="info" style="width: 100px; margin-top: 10px;margin-right: 20px;">重置信息</el-button>
						<el-button @click="SaveInfo" type="primary" style="width: 100px; margin-top: 10px;">保存信息</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div>
			<el-dialog
				:visible.sync="this.dialogVisible"
				title= "提示"
				width="30%"
				:show-close = 'false'
			>
				<span style="font-size: 20px;">{{this.dialogMessage}}</span>
				<template #footer>
				  <span class="dialog-footer">
					<el-button type="primary" @click="dialogVisible = false">确定</el-button>
				  </span>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				form: {},
				isShow: false,
				dialogVisible: false,
				dialogMessage: '',
			}
		},
		methods: {
			toShow() {
				this.$router.push("/show");
			},
			clearDS(){
				this.isShow = false;
				this.form.DSBH = '';
				this.form.DSBHYY = '';
				this.form.YXYGDSYY = '';
				this.form.YXYGDS = '';
				this.form.YXYGDCYY = '';
				this.form.YXYGDC = '';
				this.form.YXYGXYY = '';
				this.form.YXYGX = '';
				this.form.SJDSDSYY = '';
				this.form.SJDSDS = '';
				this.form.SJDSDCYY = '';
				this.form.SJDSDC = '';
				this.form.SJDSXYY = '';
				this.form.SJDSX = '';
			},
			clearInfo() {
				this.form = {};
				this.isShow = false;
			},
			async getPatientInfo() {
				console.log("获取信息：", this.form.PapmiDJH);
				if (!this.form.PapmiDJH) {
					console.log("登记号未录入");
					this.form = {};
					this.isShow = false;
					return
				} else if (this.form.PapmiDJH.length > 10) {
					console.log("登记号过长");
					this.dialogVisible = true;
					this.dialogMessage = "登记号过长-请您检查登记号格式！";
					console.log(this.dialogMessage, this.dialogVisible);
					return;
				} else if (this.form.PapmiDJH && this.form.PapmiDJH.length > 0) {
					this.form.PapmiDJH = this.form.PapmiDJH.padStart(10, '0');
				}  
				const soapRequest = `
				        <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org">
				           <soapenv:Header/>
				           <soapenv:Body>
				              <tem:GetPapmi>
				                 <!--Optional:-->
				                 <tem:Input>{"PapmiNo": "` + this.form.PapmiDJH + `"}</tem:Input>
				              </tem:GetPapmi>
				           </soapenv:Body>
				        </soapenv:Envelope>
				      `;
				const config = {
					headers: {
						'Content-Type': 'text/xml;charset=UTF-8',
						'SOAPAction': 'http://tempuri.org/YKYY.WFJTT.JG.GetPapmi.BS.GetPapmi.GetPapmi',
						'X-Requested-With': 'XMLHttpRequest',
						'Cache-Control': 'no-cache'
					},
				};
				const response = await axios.post('/api/csp/i-MEDI/YKYY.WFJTT.JG.GetPapmi.BS.GetPapmi.CLS',
					soapRequest, config);
				if (response.status === 200) {
					let soapData = this.x2js.xml2js(response.data);
					let jsonObj = JSON.parse(soapData.Envelope.Body.GetPapmiResponse.GetPapmiResult);
					this.form = jsonObj;
					if(jsonObj.SJDSDSYY && jsonObj.YXYGDSYY){
						this.isShow = true;
					}
					if(jsonObj.SJDSDS && jsonObj.YXYGDS){
						this.isShow = true;
					}
				}
			},
			async SaveInfo() {
				const soapRequest = `
				        <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org">
				           <soapenv:Header/>
				           <soapenv:Body>
				              <tem:SavePapmi>
				                 <tem:Input>{"PapmiNo":"` + this.form.PapmiDJH + `","PapmiName":"` + this.form.PapmiName + `","PapmiSex":"` + this.form.PapmiSex + `","PapmiDob":"` + this.form.PapmiDob + `","PapmiAge":"` + this.form.PapmiAge + `","PapmiTelH":"` + this.form.PapmiTelH + `","YXYGDS":"` + this.form.YXYGDS + `","YXYGDC":"` + this.form.YXYGDC + `","YXYGX":"` + this.form.YXYGX + `","SJDSDS":"` + this.form.SJDSDS + `","SJDSDC":"` + this.form.SJDSDC + `","SJDSX":"` + this.form.SJDSX + `","DSBH":"` + this.form.DSBH + `","YXYGDSYY":"` + this.form.YXYGDSYY + `","YXYGDCYY":"` + this.form.YXYGDCYY + `","YXYGXYY":"` + this.form.YXYGXYY + `","SJDSDSYY":"` + this.form.SJDSDSYY + `","SJDSDCYY":"` + this.form.SJDSDCYY + `","SJDSXYY":"` + this.form.SJDSXYY + `","DSBHYY":"` + this.form.DSBHYY + `"}</tem:Input>
				              </tem:SavePapmi>
				           </soapenv:Body>
				        </soapenv:Envelope>
				      `;
				const config = {
				        headers: {
				            'Content-Type': 'text/xml;charset=UTF-8',
				            'SOAPAction': 'http://tempuri.org/YKYY.WFJTT.JG.GetPapmi.BS.GetPapmi.SavePapmi',
							'X-Requested-With': 'XMLHttpRequest',
							'Cache-Control': 'no-cache'
				        },
				    };
				const response = await axios.post('/api/csp/i-MEDI//YKYY.WFJTT.JG.GetPapmi.BS.GetPapmi.cls', soapRequest, config);
				if(response.status === 200){
					let soapData = this.x2js.xml2js(response.data);
					let jsonObj = JSON.parse(soapData.Envelope.Body.SavePapmiResponse.SavePapmiResult);
					this.dialogVisible = true;
					this.dialogMessage = "保存成功！";
					this.form = {};
				}
			},
			leftDegree() {
				if(!this.form.YXYGDS || !this.form.SJDSDS ){
					return
				} else if (this.form.YXYGDS && this.form.SJDSDS) {
					this.form.DSBH = (this.form.SJDSDS - this.form.YXYGDS).toFixed(2);
					this.isShow = true;
				}
			},
			rightDegree() {
				if(!this.form.YXYGDSYY || !this.form.SJDSDSYY ){
					return
				} else if(this.form.YXYGDSYY && this.form.SJDSDSYY ){
					this.form.DSBHYY = (this.form.SJDSDSYY - this.form.YXYGDSYY).toFixed(2);
					this.isShow = true;
				}
			},
		},
		watch: {
		}
	}
</script>

<style scoped>
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	  -webkit-appearance: none !important;
	}
	input[type="number"]{
	  -moz-appearance: textfield !important;
	}
	.color-red /deep/ .el-input__inner{
		color: #ff0000;
	}
	.color-black /deep/ .el-input__inner{
		color: #000 !important;
	}
</style>